/**
 * Shared constants for inline edit components
 * @version 1.0.0
 * @since 2026-02-05
 */
/**
 * Default placeholder text displayed when inline edit fields are empty.
 * Used across InlineText, InlineDate, and InlineSelect components.
 */
export const DEFAULT_INLINE_PLACEHOLDER = '--';
/**
 * Translation namespace for inline edit components
 */
export const INLINE_EDIT_NAMESPACE = 'ui.inline_edit';
